"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var dateTime_exports = {};
__export(dateTime_exports, {
  DATE_FORMAT: () => DATE_FORMAT,
  SQL_FORMAT: () => SQL_FORMAT,
  TIME_ZONE: () => TIME_ZONE,
  US_FORMAT: () => US_FORMAT,
  currentDayString: () => currentDayString,
  currentMonthString: () => currentMonthString,
  currentYearString: () => currentYearString,
  dateTime: () => dateTime,
  dateTimeISO8601String: () => dateTimeISO8601String,
  dateTimeISO8601StringWithoutZone: () => dateTimeISO8601StringWithoutZone,
  dateTimeSQLString: () => dateTimeSQLString,
  dateTimeSqlStringWithoutZone: () => dateTimeSqlStringWithoutZone,
  dateTimeString: () => dateTimeString,
  parseDateTime: () => parseDateTime
});
module.exports = __toCommonJS(dateTime_exports);
var import_luxon = require("luxon");
const US_FORMAT = "LL/dd/yyyy TT";
const SQL_FORMAT = "yyyy-LL-dd TT";
const DATE_FORMAT = "yyyy-LL-dd";
const TIME_ZONE = "America/New_York";
const dateTime = (unixTimeStamp = Date.now(), timezone = TIME_ZONE) => {
  return import_luxon.DateTime.fromMillis(unixTimeStamp).setZone(timezone);
};
const dateTimeString = (dt = dateTime(), format = US_FORMAT) => {
  return dt.toFormat(format);
};
const currentYearString = (dt = dateTime(), format = "yyyy") => dateTimeString(dt, format);
const currentMonthString = (dt = dateTime(), format = "LL") => dateTimeString(dt, format);
const currentDayString = (dt = dateTime(), format = "dd") => dateTimeString(dt, format);
const dateTimeSQLString = (dt = dateTime(), format = SQL_FORMAT) => {
  return dateTimeString(dt, format);
};
const dateTimeISO8601String = (dt = dateTime()) => {
  return dt.setZone("UTC").toISO();
};
const dateTimeISO8601StringWithoutZone = (dt = dateTime(), format = `yyyy-LL-dd'T'TT.SSS`) => {
  return dateTimeString(dt, format);
};
const dateTimeSqlStringWithoutZone = (dt = dateTime(), format = `yyyy-LL-dd TT.SSS`) => {
  return dateTimeString(dt, format);
};
const parseDateTime = (value, style = "jsDate", format, options = { zone: TIME_ZONE }, throwIfInvalid = true) => {
  let dt;
  switch (style) {
    case "jsDate":
      dt = import_luxon.DateTime.fromJSDate(value, options);
      break;
    case "iso":
      dt = import_luxon.DateTime.fromISO(value, options);
      break;
    case "us":
      dt = import_luxon.DateTime.fromFormat(value, US_FORMAT, options);
      break;
    case "sql":
      dt = import_luxon.DateTime.fromSQL(value, options);
      break;
    case "millis":
      dt = import_luxon.DateTime.fromMillis(value, options);
      break;
    case "seconds":
      dt = import_luxon.DateTime.fromSeconds(value, options);
      break;
    case "custom":
      dt = import_luxon.DateTime.fromFormat(value, format, options);
      break;
    default:
      throw new Error(`Unknown style of ${style}`);
  }
  if (!dt.isValid && throwIfInvalid) {
    throw new Error(dt.invalid.reason || `Not a valid dateTime object.`);
  }
  return dt;
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  DATE_FORMAT,
  SQL_FORMAT,
  TIME_ZONE,
  US_FORMAT,
  currentDayString,
  currentMonthString,
  currentYearString,
  dateTime,
  dateTimeISO8601String,
  dateTimeISO8601StringWithoutZone,
  dateTimeSQLString,
  dateTimeSqlStringWithoutZone,
  dateTimeString,
  parseDateTime
});
//# sourceMappingURL=dateTime.js.map
